import { useMemo } from "react";

/**
 * Devuelve { [seccion]: string[] } con la lista de campos faltantes por sección.
 * Sección "completa" cuando el array está vacío.
 *
 * Basado en validaciones BLANDAS — nunca bloquea el guardado del BORRADOR.
 * Alimenta los chips "Incompleto" del nav y los Alerts warning de cada sección.
 */
export const useSectionCompleteness = (values) =>
  useMemo(() => {
    const faltan = {
      portada: [],
      quienesSomos: [],
      antecedentes: [],
      estructura: [],
      fasesServicios: [],
      equipo: [],
      infoAdicional: [],
    };

    if (!values.solicitanteId && !values.solicitanteNuevo)
      faltan.portada.push("solicitante");
    if (!values.sucursal) faltan.portada.push("sucursal");
    if (!values.titulo) faltan.portada.push("título");

    if (!values.resumenEjecutivo) faltan.quienesSomos.push("resumen ejecutivo");

    if (!values.antecedentes) faltan.antecedentes.push("antecedentes");
    if (!values.alcance) faltan.estructura.push("alcance");

    if (values.items.length === 0) {
      faltan.fasesServicios.push("sin fases (mínimo 1 al enviar)");
    } else {
      values.items.forEach((it, i) => {
        if (!it.refCliente)
          faltan.fasesServicios.push(`fase ${i + 1}: cliente`);
        if (!it.refEmpleado)
          faltan.fasesServicios.push(`fase ${i + 1}: responsable`);
        if (it.tipoItem === "PLAN" && !it.refTipoPlan)
          faltan.fasesServicios.push(`fase ${i + 1}: servicio del catálogo`);
      });
    }

    if (!values.vendedor) faltan.equipo.push("vendedor");
    if (values.equipo.length === 0)
      faltan.equipo.push("equipo vacío (mínimo 1 al enviar)");

    if (!values.condicionesPago)
      faltan.infoAdicional.push("condiciones de pago");
    if (!values.proximosPasos) faltan.infoAdicional.push("próximos pasos");

    return faltan;
  }, [values]);
